import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';

// Components
import Navbar from './components/layout/Navbar';
import ProtectedRoute from './components/auth/ProtectedRoute';
import AdminLayout from './components/admin/AdminLayout';

// Pages
import Home from './pages/Home';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import ForgotPassword from './components/auth/ForgotPassword';
import TaskList from './components/tasks/TaskList';
import TaskDetail from './pages/TaskDetail';
import CreateTask from './pages/CreateTask';
import Profile from './pages/Profile';  
import MessagesPage from './pages/MessagesPage';
import AdminDashboard from './pages/admin/DashBoard';
import UsersManagement from './pages/admin/UsersManagement';
import MyTasks from './pages/MyTasks';
import UserDashboard from './pages/UserDashboard';
import Wallet from './pages/Wallet';
import TokenHelp from './pages/TokenHelp';
import ChatPage from './pages/ChatPage';
import ChatTest from './pages/ChatTest';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Ruta admin simplificada */}
          <Route path="/admin" element={
            <AdminLayout>
              <div className="admin-dashboard">
                <h1 className="mb-4">Panel de Administración</h1>
                
                <div className="row">
                  <div className="col-md-4 mb-4">
                    <div className="card bg-primary text-white">
                      <div className="card-body">
                        <h5 className="card-title">Usuarios</h5>
                        <h2>125</h2>
                        <p className="mb-0">
                          <span className="badge bg-light text-primary me-2">87 activos</span>
                          <span className="badge bg-light text-primary">23 nuevos este mes</span>
                        </p>
                      </div>
                    </div>
                  </div>
                  
                  <div className="col-md-4 mb-4">
                    <div className="card bg-success text-white">
                      <div className="card-body">
                        <h5 className="card-title">Tareas</h5>
                        <h2>430</h2>
                        <p className="mb-0">
                          <span className="badge bg-light text-success me-2">86 pendientes</span>
                          <span className="badge bg-light text-success">344 completadas</span>
                        </p>
                      </div>
                    </div>
                  </div>
                  
                  <div className="col-md-4 mb-4">
                    <div className="card bg-info text-white">
                      <div className="card-body">
                        <h5 className="card-title">Transacciones</h5>
                        <h2>344</h2>
                        <p className="mb-0">
                          <span className="badge bg-light text-info me-2">23450 BLUE</span>
                          <span className="badge bg-light text-info">28900 RED</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </AdminLayout>
          } />
          
          {/* Rutas normales */}
          <Route path="*" element={
            <>
              <Navbar />
              <div className="container py-4">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/forgot-password" element={<ForgotPassword />} />
                  
                  <Route path="/tasks/create" element={<ProtectedRoute><CreateTask /></ProtectedRoute>} />
                  <Route path="/tasks/:id" element={<TaskDetail />} />
                  <Route path="/tasks" element={<TaskList />} />
                  
                  <Route path="/my-tasks" element={<ProtectedRoute><MyTasks /></ProtectedRoute>} />
                  <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
                  <Route path="/messages/:userId" element={<ProtectedRoute><MessagesPage /></ProtectedRoute>} />
                  <Route path="/messages" element={<ProtectedRoute><MessagesPage /></ProtectedRoute>} />
                  <Route path="/dashboard" element={<ProtectedRoute><UserDashboard /></ProtectedRoute>} />
                  <Route path="/wallet" element={<ProtectedRoute><Wallet /></ProtectedRoute>} />
                  <Route path="/tokens/help" element={<TokenHelp />} />
                  <Route path="/chat" element={<ProtectedRoute><ChatPage /></ProtectedRoute>} />
                  <Route path="/chat/:userId" element={<ProtectedRoute><ChatPage /></ProtectedRoute>} />
                  <Route path="/chat-test" element={<ChatTest />} />
                  
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </div>
            </>
          } />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
